export const environment = {
  production: true,
  systemUrl: '/core/',
  //systemUrl: 'https://localhost:5001/',
  get apiUrl(): string {
    return this.systemUrl + 'api'
  },
  get signalRUrl(): string {
    return this.systemUrl + 'signalr'
  }
};
